/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { Grid } from '@mui/material';
import moment from 'moment';

import {
  DefaultSelectV2,
  DialogDefaultV2,
  InputV2,
  YearMonthPickerV2,
} from '../../../components/v2';

import * as actionsOlerite from '../../../store/olerite/actions';
import * as selectorsOlerite from '../../../store/olerite/reducer';
import * as selectorsAuth from '../../../store/auth/reducer';

import UsuarioContainer from './UsuarioContainer';

const createSchema = {
  tipo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  mesReferencia: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  usuarios: { presence: { allowEmpty: false, message: 'é obrigatório (mínimo 1 usuário)' } },
};

const tipoOptions = [
  { id: 'HOLERITE', nome: 'Holerite' },
  { id: 'INFORME_RENDIMENTO', nome: 'Informe de Rendimento' },
];

const Formulario = ({
  createOlerite,
  oleriteClearSelected,
  open,
  onClose,
  authData,
}) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  const getDefaultValues = () => ({
    criadoPorId: authData?.id,
    criadoPorNome: authData?.nome,
    tipo: 'HOLERITE',
    mesReferencia: moment().startOf('month').valueOf(),
    arquivos: [],
    usuarios: [],
  });

  useEffect(() => {
    if (open) {
      setValues(getDefaultValues());
      setErrors({});
    }
  }, [open, authData?.id, authData?.nome]);

  const onCloseLocal = (isSave) => {
    oleriteClearSelected();
    setErrors({});
    const defaults = getDefaultValues();
    setValues(defaults);
    onClose(isSave);
  };

  const saveCallback = (success) => {
    if (success) {
      onCloseLocal(true);
    }
  };

  const onSave = () => {
    const erros = validate(values, createSchema);
    setErrors(erros || {});
    if (!erros) {
      createOlerite(values, saveCallback);
    }
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Holerite"
      confirmMessage="Salvar"
      cancelMessage="Cancelar"
      maxWidth="md"
      fullWidth
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 4 }}>
          <DefaultSelectV2
            label="Tipo"
            name="tipo"
            isRequired
            error={!!(errors && errors.tipo)}
            options={tipoOptions}
            onSelect={(e) =>
              setValues({ ...values, tipo: e.target.value || null })}
            value={values.tipo}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <YearMonthPickerV2
            label={
              values.tipo === 'HOLERITE'
                ? 'Mês Referência'
                : 'Ano de Referência'
            }
            value={values.mesReferencia}
            onChange={(val) => setValues({ ...values, mesReferencia: val })}
            error={!!errors?.mesReferencia}
            isRequired
            onlyYear={values.tipo === 'INFORME_RENDIMENTO'}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <InputV2
            label="Criado Por"
            name="criadoPorNome"
            value={values.criadoPorNome || ''}
            disabled
          />
        </Grid>
        <UsuarioContainer
          usuarios={values.usuarios}
          onSave={(usuarios) => setValues({ ...values, usuarios })}
          showError={!!errors?.usuarios}
        />
      </Grid>
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  createOlerite: PropTypes.func.isRequired,
  oleriteClearSelected: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  authData: PropTypes.object,
};

Formulario.defaultProps = {
  authData: {},
};

const mapStateToProps = (state) => ({
  selectedOlerite: selectorsOlerite.getSelectedOlerite(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...actionsOlerite }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Formulario);
